export default "__VITE_ASSET__DEl4foYY__"